export const getEventPostMessage = (windowType: any, postMessage: string | Record<string, unknown>, attributeName: string) => {
  if (windowType?.length > 0) {
    for (let i = 0; i < windowType.length; i++) {
      if (windowType[i]?.name === attributeName) {
        windowType[i]?.contentWindow?.postMessage(postMessage, '*')
        return false
      }
    }
  }
  return false
}